module.exports = __webpack_public_path__ + "static/media/mini-abe.6476cd89.png";